import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import store from '../../Store';
import ModalLink from './ComponentModalLink';
import ModalDelete from './ComponentModalDelete';
const documentDeleteModal = document.getElementById('document_delete_modal');
const documentDeleteButtons = document.getElementsByName('document_delete');
if (documentDeleteButtons.length && documentDeleteModal) {
    render(_jsx(Provider, Object.assign({ store: store }, { children: _jsx(ModalDelete, {}) })), documentDeleteModal);
    Array.prototype.forEach.call(documentDeleteButtons, (button) => {
        const id = parseInt(button.getAttribute('data-id'), 10);
        const title = button.getAttribute('data-title');
        render(_jsx(Provider, Object.assign({ store: store }, { children: _jsx(ModalLink, Object.assign({ modalKey: "document_delete", id: id, name: title }, { children: button.childNodes[0].parentNode.innerHTML })) })), button);
    });
}
// If query params contains download_document, download it!
const urlParams = new URLSearchParams(window.location.search);
const shouldDownloadDocument = urlParams.get('downloadDocument');
if (shouldDownloadDocument) {
    window.location.href = `/my-documents/download/${shouldDownloadDocument}`;
}
